import {connect} from 'react-redux';
import TermsOfUse from './TermsOfUse';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';

export default connect(null, {setNavigationAnnouncement})(TermsOfUse);
